import { render, staticRenderFns } from "./addperson.vue?vue&type=template&id=06a085e5&scoped=true"
import script from "./addperson.vue?vue&type=script&lang=js"
export * from "./addperson.vue?vue&type=script&lang=js"
import style0 from "./addperson.vue?vue&type=style&index=0&id=06a085e5&prod&lang=scss&scoped=true"
import style1 from "./addperson.vue?vue&type=style&index=1&id=06a085e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a085e5",
  null
  
)

export default component.exports